// extracted by mini-css-extract-plugin
export default {"nextCta":"DataSource_nextCta__aA6uG","skipCta":"DataSource_skipCta__ExAdj"};